import { render, staticRenderFns } from "./BaseButtonNext.vue?vue&type=template&id=6062f95f&scoped=true"
import script from "./BaseButtonNext.vue?vue&type=script&lang=js"
export * from "./BaseButtonNext.vue?vue&type=script&lang=js"
import style0 from "./BaseButtonNext.vue?vue&type=style&index=0&id=6062f95f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6062f95f",
  null
  
)

export default component.exports